<template>
	<drawer
			title="Add new document"
			:hide-overlay="true"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<field
				margin="0 0 10px 0"
				:class-error="getError('type_id')"
				@updateSelect="onSelect($event, 'type_id')"
				:autocompleteValue="type_id"
				:items="documentsTypes"
				label="Document type"
				item-text="name"
				item-value="id"
				is-select
				:isClearable="false"
				is-attach
				is-required
		></field>
		<field
				:class-error="$v.fileItem.value.$error"
				margin="0 10px 0 0"
				width="300px"
				label="File"
				placeholder="Add file"
				:setInputValue="fileItem.name"
				:is-file-icon="!!fileItem.name"
				@updateFile="setNewItem($event)"
				@updateView="onView"
				color-icon="#19BC38"
				is-file
				is-readonly
		></field>
	</drawer>
</template>

<script>

import Drawer from "@/shared/Drawer/Drawer";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "EditDocument",
	mixins: [ validationMixin ],
	components: { Drawer },
	props: {
		item: Object,
		dialogFlag: String,
		documentsTypes: Array,
	},

	computed: {

	},

	validations: {
		type_id: { required },
		fileItem: {
			value: { required }
		}
	},

	data() {
		return {
			fileItem: {
				name: "",
				value: '',
			},
			uniqKey: null,
			type_id: null,

		};
	},
	methods: {
		setNewItem(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.fileItem.name = iFile.name;
				this.fileItem.value = reader.result;
			};
		},

		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onView() {
			const { value } = this.fileItem;
			this.$emit('updateView', value);
		},

		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const { type_id, fileItem, uniqKey } = this.$data;
				this.$emit('updateSave', { type_id, name: fileItem.name, value: fileItem.value, uniqKey });
			} else {
				this.$store.dispatch('setAlert', { type: "error", message: "Saving error" });
			}
		},

		onClose() {
			this.$emit('updateClose');
		},

		onSelect({ value }, key) {

			// this[key] = value;

			if (key === 'type_id') {
				const { id } = value;

				this.type_id = id;
			}
		},

		onInput({ value }, key) {
			this[key] = value;
		},
	},

};

</script>

